<script>
import { mapActions } from 'vuex'
import { list, get, del } from '@/api/marca'

// Colunas
import columns from './colunas'

export default {
  props: {
    mode: { type: String, default: 'tab' }
  },
  async mounted () {
    this.modalAdd = await this.newModal({
      component: 'app-marca-edit',
      width: 300,
      onSave: async (data) => {
        if (data.grupo) this.refresh(data.grupo)
        else this.$refs.completeGrid.refreshList()
      },
      onCancel: () => {
        this.$refs.completeGrid.focoPesquisa()
      }
    })
  },
  data () {
    return {
      tela: 'marca',
      acoes: {
        add: 'marca_incluir',
        edit: 'marca_editar',
        delete: 'marca_excluir'
      },
      modalAdd: false,
      columns: columns,
      indices: [
        // 'marca_descricao', 'marca_formula', 'qtde_parc_marca'
        { value: 'marca', label: 'Marca' },
        { value: 'codigo_externo', label: 'Código Externo' },
        { value: 'sincronizado', label: 'Sincronizado' }
      ]
    }
  },
  methods: {
    ...mapActions({
      newModal: 'modal/new',
      openModal: 'modal/open',
      confirmarModal: 'modal/confirmar',
      toaster: 'modal/toaster'
    }),
    refresh (data) {
      if (this.mode === 'tab') this.$refs.completeGrid.refreshList()
      else if (this.mode === 'modal') this.$refs.completeGrid.changeBusca(data)
    },
    async getList (filtros) {
      let data = await list(filtros)
      return {
        data: data.data,
        totalCount: data.total
      }
    },
    async novo () {
      let data = {
        marca: null,
        codigo_externo: null,
        sincronizado: 'S'
      }
      this.openModal({ modal: this.modalAdd, data })
    },
    async editar (row) {
      let data = await get(row.data.id)
      this.openModal({ modal: this.modalAdd, data })
    },
    async excluir (row) {
      this.confirmarModal({
        msg: 'Deseja realmente excluir esse grupo?',
        onConfirm: async () => {
          await del(row.data.id)
          this.toaster({ message: 'Excluido com sucesso!', color: 'success' })
          this.$refs.completeGrid.refreshList()
        }
      })
    },
    async selecionar (selecionado) {
      if (selecionado.id) this.$emit('save', selecionado)
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Listar Marca" @onClose="() => $emit('cancel')">
    <ui-complete-grid
      ref="completeGrid"
      :tela="tela"
      :columns="columns"
      :indices="indices"
      :selection="mode === 'modal'"
      :datasource="getList"
      :acoes="acoes"
      @onSelect="selecionar"
      @onCancel="$emit('cancel')"
      @onAdd="novo"
      @onEdit="editar"
      @onDelete="excluir" />
  </ui-layout-modal>
</template>
